exports = module.exports = require("../../../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".keyboard-center .keyboard-container {\n  padding-top: 10px; }\n\n.form-group {\n  margin-bottom: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Magento2/gs-kiosk/src/app/routes/completeprofile/completeprofile.component.scss
// module id = ../../../../../src/app/routes/completeprofile/completeprofile.component.scss
// module chunks = main